import React from 'react';
import { SettingsHubSection } from '../SettingsHubSection';

const ToolsSettingsSection: React.FC = () => (
  <SettingsHubSection section="tools" />
);

export default ToolsSettingsSection;
